import Navbar from "@/components/Navbar";
import WaxBallCanvas from "./components/WaxBallCanvas";

export default function Wakbbu() {
  return (
    <main className="relative w-full h-dvh overflow-hidden">
      <Navbar />
      <WaxBallCanvas />
    </main>
  );
}
